import defaultReducer from "./defaultReducer";

const initialComplianceEvents = [
  {
    text: "Interactions",
    value: "Customer Interaction",
  },
  {
    text: "Observations",
    value: "Observations",
  },
  {
    text: "Gambling Dispute",
    value: "GamblingDisputeType",
  },
  {
    text: "Customer Incident",
    value: "IncidentType",
  },
  {
    text: "Suspicious Activity",
    value: "SuspiciousActivityType",
  },
  {
    text: "Enforcement Visit",
    value: "EnforcementVisitType",
  },
  {
    text: "Think 25 Challenge",
    value: "IdType",
  },
  {
    text: "Customer Profile",
    value: "Customer",
  },
  {
    text: "Authorisation Required",
    value: "EventType",
  },
];

export const complianceMetadata = defaultReducer(
  "FETCH_COMPLIANCE_METADATA",
  [],
);
export const activeComplianceModule = defaultReducer(
  "SET_ACTIVE_COMPLIANCE_MODULE",
  {},
);
export const complianceModel = defaultReducer("FETCH_COMPLIANCE_MODEL", {});
export const complianceRecords = defaultReducer("FETCH_COMPLIANCE_REC", {});
export const complianceEvents = defaultReducer(
  "FETCH_COMPLIANCE_EVENTS",
  initialComplianceEvents,
);
export const complianceCustomerConfig = defaultReducer(
  "FETCH_COMPLIANCE_CUSTOMER_CONFIG",
  {},
);
export const complianceAlertConfig = defaultReducer(
  "FETCH_COMPLIANCE_ALERT_CONFIG",
  {},
);
export const complianceAgeConfig = defaultReducer(
  "FETCH_COMPLIANCE_AGE_CONFIG",
  {},
);
export const complianceCustomerInteractionConfig = defaultReducer(
  "FETCH_COMPLIANCE_CUSTOMER_INTERACTION_CONFIG",
  {},
);

export const ageConfigLabels = {
  hasChildrenInGamingArea: "Record children in the gaming area",
  hasNoIdCustomerDescription: "Capture customer description if no ID",
};
